module.exports = __webpack_public_path__ + "img/Bonos.6ee5d2bb.png";